import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

/**
 * iOS-style segmented control used in the Analytics header.
 *
 * Visual contract: rounded pill background, neutral fill, the selected
 * segment gets an elevated white pill — no MUI outlines or borders.
 */
const SegmentedTabs = ({ value, onChange, options }) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        bgcolor: "rgba(0,0,0,0.05)",
        p: "3px",
        borderRadius: "10px",
        width: "100%",
      }}
    >
      <ToggleButtonGroup
        exclusive
        value={value}
        onChange={(_, next) => next && onChange(next)}
        sx={{
          width: "100%",
          gap: 0,
          "& .MuiToggleButton-root": {
            flex: 1,
            minWidth: 0,
            border: "none",
            borderRadius: "8px !important",
            textTransform: "none",
            fontWeight: 400,
            fontSize: "0.8125rem",
            px: 1.25,
            py: 0.75,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "rgba(0,0,0,0.5)",
            transition: "all 160ms ease",
            "&:hover": {
              bgcolor: "transparent",
              color: "rgba(0,0,0,0.88)",
              fontWeight: 600,
            },
            "&.Mui-selected": {
              bgcolor: "#fff",
              color: "rgba(0,0,0,0.88)",
              fontWeight: 600,
              boxShadow: "0 1px 3px rgba(0,0,0,0.08), 0 1px 1px rgba(0,0,0,0.04)",
              "&:hover": { bgcolor: "#fff" },
            },
          },
        }}
      >
        {options.map((opt) => (
          <ToggleButton
            key={opt.value}
            value={opt.value}
            aria-label={opt.label}
            disabled={!!opt.disabled}
          >
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default SegmentedTabs;
